import { useEffect, useState } from 'react'
import { mesh, type MeshPeer, type RingEntry } from '../lib/mesh'

export function useMesh() {
  const [peers, setPeers] = useState<MeshPeer[]>([])
  const [ring, setRing] = useState<RingEntry[]>([])

  useEffect(() => {
    mesh.init()
    const update = () => {
      setPeers(mesh.getPeers())
      setRing(mesh.getRing())
    }
    update()
    const unsub = mesh.subscribeChange(update)
    return unsub
  }, [])

  return { peers, ring, mesh }
}
